<template>
  <span>
    <v-btn
      small
      @click="checkAccessAndAddToCalendar"
      :loading="loading"
      :disabled="loading"
      v-bind="$attrs"
    >
      Add to Google Calendar
    </v-btn>

    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Google Calendar Authorization Required</span>
        </v-card-title>
        <v-card-text>
          <p>
            To add this schedule to your Google Calendar, you need to grant this
            application the necessary access to your Google Calendar. Please
            click the "Authorize" button to do this.
          </p>

          <google-authorization-button
            v-if="showAuthorizationButton"
            @on-authorized="saveGoogleAuthorization"
            :clientId="googleClientId"
            :scopes="getCalendarScopes()"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import GoogleAuthorizationButton from "@/components/auth/oauth/GoogleAuthorizationButton.vue";
import { GOOGLE_OAUTH_SCOPES } from "@/components/auth/oauth/googleScopes.js";
import { mapActions } from "vuex";

export default {
  components: { GoogleAuthorizationButton },
  props: {
    schedule: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    dialog: false,
    showAuthorizationButton: false,
    googleClientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
    loading: false,
  }),
  methods: {
    ...mapActions(["addErrorMessage", "addSuccessMessage", "clearMessage"]),

    checkAccessAndAddToCalendar() {
      this.loading = true; // Set loading to true when the function is called

      // Call the /access-check endpoint to check if user has access
      this.$axios
        .get("/google-token/access-check", {
          params: { scopes: this.getCalendarScopes() },
        })
        .then((response) => {
          if (response.data) {
            // If user has access, add schedule to Google Calendar
            this.addToGoogleCalendar();
          } else {
            // If user doesn't have access, show dialog and authorization button
            this.dialog = true;
            this.showAuthorizationButton = true;
            this.loading = false;
          }
        });
    },
    addToGoogleCalendar() {
      this.$axios
        .post(
          "/teacher-schedule/sync-google-calendar/" + this.schedule.scheduleId
        )
        .then((resp) => {
          const event = resp.data;
          this.$emit('on-success', event)
          this.addSuccessMessage("Schedule added to Google Calendar");
        })
        .catch((error) => {
          this.addErrorMessage(
            "Error adding schedule to Google Calendar" || error.data.messages
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    saveGoogleAuthorization({ authorizationCode, scopes }) {
      this.loading = true;
      const data = {
        authorizationCode,
        scopes,
      };
      this.$axios
        .post("/google-token", data)
        .then((response) => {
          console.log(response);
          // After authorization is granted, add schedule to Google Calendar
          this.addToGoogleCalendar();
          this.showAuthorizationButton = false;

          this.addSuccessMessage(
            "Granted application access to Google Calendar"
          );
          this.dialog = false;
        })
        .catch((error) => {
          this.loading = false;
          this.addErrorMessage(
            "Error granting access to Google Calendar" || error.data.messages
          );
        });
    },
    getCalendarScopes() {
      const calendarScopes = [GOOGLE_OAUTH_SCOPES.GOOGLE_CALENDAR.CALENDAR];

      return calendarScopes.join(",");
    },
  },
};
</script>
